import React from 'react';
import { useI18n } from '../useI18n.js';

export function Scores({ scores, chefName, guessedPlayers = [] }) {
  const { t } = useI18n();
  return (
    <div className="card" style={{ position: 'relative' }}>
      <span className="container-emoji-badge">🏆</span>
      <h3>{t('scores')}</h3>
      <ul>
        {Object.entries(scores).map(([p, s]) => (
          <li key={p}>
            {p === chefName ? '👑' : ''}
            {guessedPlayers.includes(p) ? '⚪ ' : ''}
            {p}: {s}
          </li>
        ))}
      </ul>
    </div>
  );
}
